<template>
  <div class="sign-in">
    <Connect-With-Google
      :connectWithGoogleAuth="connectWithGoogleAuthSignIn"
      :authErrorMsg="authErrorMsg"
      :googleAuthLoading="googleAuthLoading"
      :setShowSignUp="setShowSignUp"
    />
    <div class="option-separator">
      <div class="separator-border" />
      <div class="separator-text">OR</div>
    </div>
    <div class="input-wrapper">
      <labeL>Email</labeL>
      <input
        type="text"
        class="input-box"
        id="userEmail"
        placeholder="Email"
        v-model="userEmail"
        @change="onEmailChange"
        @blur="onEmailChange"
      />
      <span class="error-wrapper" v-if="emailErrorMsg !== ''">{{
        emailErrorMsg
      }}</span>
    </div>
    <div class="input-wrapper">
      <labeL>Password</labeL>
      <input
        type="password"
        class="input-box"
        id="userPassword"
        placeholder="Password"
        v-model="userPassword"
        @change="onPasswordChange"
        @blur="onPasswordChange"
      />
      <span class="error-wrapper" v-if="passwordErrorMsg !== ''">
        {{ passwordErrorMsg }}
      </span>
    </div>
    <div class="error-wrapper" v-if="loginFailure">
      Please check your Username or Password
    </div>

    <V-Button
      className="action-btn"
      :text="'SIGN IN'"
      :loading="loading"
      :callback="userSignIn"
      :newLoader="true"
    >
    </V-Button>

    <div class="switch-section">
      <span class="anchor-link" @click="setShowSignUp"
        >Don't have an account?</span
      >
      <span class="anchor-link" @click="setShowForgotPassword"
        >Forgot password?</span
      >
    </div>
  </div>
</template>

<script>
import { post } from '../../assets/util/rest'
import { URLS } from '../../assets/util/constants/constants'
import ConnectWithGoogle from './ConnectWithGoogle'
import button from '@/components/Button'
import sharedFunctions from '@/assets/util/functions'

export default {
  name: 'SignInView',
  props: [
    'showPopup',
    'validateEmail',
    'validatePassword',
    'setShowSignUp',
    'setShowForgotPassword',
    'connectWithGoogleAuth',
    'authErrorMsg',
    'googleAuthLoading'
  ],
  components: {
    'Connect-With-Google': ConnectWithGoogle,
    'V-Button': button
  },
  data: function() {
    return {
      userEmail: '',
      userPassword: '',
      emailErrorMsg: '',
      passwordErrorMsg: '',
      loginFailure: false,
      loading: false
    }
  },
  methods: {
    onEmailChange() {
      this.emailErrorMsg = this.validateEmail(this.userEmail)
    },
    onPasswordChange() {
      this.passwordErrorMsg = this.validatePassword(this.userPassword)
    },
    connectWithGoogleAuthSignIn() {
      this.connectWithGoogleAuth(true)
    },
    userSignIn() {
      this.loginFailure = false
      this.emailErrorMsg = this.validateEmail(this.userEmail)
      this.passwordErrorMsg = this.validatePassword(this.userPassword)

      if (this.emailErrorMsg == '' && this.passwordErrorMsg == '') {
        const userData = {}
        userData.email = this.userEmail.toLowerCase()
        userData.password = this.userPassword
        this.loading = true
        post(
          URLS.loginUser +
            '?j_username=' +
            this.userEmail +
            '&j_password=' +
            this.userPassword
        )
          .then(res => {
            res.json().then(response => {
              if (
                response &&
                response.success != undefined &&
                response.success == 'true'
              ) {
                sharedFunctions.mixpanelIdentify(this.userEmail)
                sharedFunctions.mixpanelUpdateProfileProperty({
                  'Last Login': new Date().toISOString()
                })
                window.location.reload()
              } else {
                this.loginFailure = true
              }
              this.loading = false
            })
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.sign-in {
  .action-btn {
    background: #abd46e !important;
    border-color: #abd46e !important;
    border: 0 !important;
    box-shadow: none !important;
  }
  .switch-section {
    display: flex;
    justify-content: space-between;
    .anchor-link {
      font-size: 12px !important;
    }
  }
}
</style>
